import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import GenericFormDrawer from '../../../components/GenericFormDrawer';
import { updateFeedbackAnalyticsSettings } from '../../../services/performanceFeedbackAnalyticsService';

// Kullanıcı kararı A3 — "1:1 → İK'ya yalnız SAYI, ekip düzeyinde, kiracı ayarıyla". Yalnız İK değiştirir (sunucu denetler,
// denetim kaydı yazar). İkinci ayar: özel takdirin toplam sayılara katılması (toplulaştırma izni). İçerik hiçbir ayarla açılmaz.
export default function FeedbackSettingsDrawer({ open, onClose, settings, onSaved }) {
  const { t } = useTranslation();
  const initial = useMemo(() => (open ? {
    oneOnOneCountsEnabled: !!settings?.oneOnOneCountsEnabled,
    privateRecognitionCountsEnabled: !!settings?.privateRecognitionCountsEnabled,
  } : undefined), [open, settings]);

  const schema = [
    { name: 'notice', type: 'notice', content: t('performance.feedbackAnalytics.settings.notice') },
    { name: 'oneOnOneCountsEnabled', type: 'checkbox', label: t('performance.feedbackAnalytics.settings.oneOnOne'), grid: 12 },
    { name: 'privateRecognitionCountsEnabled', type: 'checkbox', label: t('performance.feedbackAnalytics.settings.privateRecognition'), grid: 12 },
  ];

  return (
    <GenericFormDrawer
      open={open}
      onClose={onClose}
      title={t('performance.feedbackAnalytics.settings.title')}
      schema={schema}
      initialValues={initial}
      submitLabel={t('common.save')}
      onSave={async (values) => {
        try {
          const res = await updateFeedbackAnalyticsSettings({
            oneOnOneCountsEnabled: !!values.oneOnOneCountsEnabled,
            privateRecognitionCountsEnabled: !!values.privateRecognitionCountsEnabled,
          });
          if (!res?.data?.status) return false;
          onSaved?.(res.data.data);
          return true;
        } catch {
          return false;   // hata tostu interceptor'da
        }
      }}
    />
  );
}
